import apiClient from "../apiClient";

const resource = "doctors";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getAppointments: id => apiClient.get(`${resource}/${id}/Appointments`),
    addAppointments: (id, payload) => apiClient.post(`${resource}/${id}/Appointments`,payload),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    getDoctorServiceRates: id => apiClient.get(`${resource}/${id}/serviceRates`),
    add: payload => apiClient.post(`${resource}`, payload),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),
    serviceManagement: (id, payload) => apiClient.put(`${resource}/${id}/serviceManagement`, payload),
    lock: id => apiClient.put(`${resource}/${id}/lock`),
    unlock: id => apiClient.put(`${resource}/${id}/unlock`),
    delete: id => apiClient.delete(`${resource}/${id}`),
    getJobGrades: id => apiClient.get(`${resource}/${id}/jobGrades`),
    editJobGrades: (id, payload) => apiClient.put(`${resource}/${id}/jobGrades`, payload),

};
